//All End-points are in this file...
import axios from "axios";
import { post, get } from "./Https";
import {
  getOrchestrationHttpBaseUrl,
  shouldUseServerSessionAuth,
} from "../utils/authCookie";

//Terms and condition agreement Api
export const AcceptEndUserAgreement = () => {
  return get("/drx/api/dashboard/acceptEndUserAgreement.do");
};

//Global dropdowns
export const GetGlobalDropdown = (params: any) => {
  return get("/drx/api/properties/initalize.do?" + params);
};

//Dashboard graph report
export const DashboardGraphReport = (params: any) => {
  return get("/drx/api/dashboard/reportdata.do?" + params);
};

//Patient details which is left Card
export const PatientDetailsOfLeftcard = (params: any) => {
  return get("/drx/api/rxpad/patientdetails.do?" + params);
};

//Login with email
export const LoginWithEmail = (data: any) => {
  if (shouldUseServerSessionAuth()) {
    return axios.post(
      `${getOrchestrationHttpBaseUrl()}/auth/session/login`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
  }
  return post("drx/api/auth/authenticate.do", data);
};

//update Login Password
export const UpdateLoginPassword = (data: any) => {
  return post("/drx/api/myprofile/password/update.do", data);
};

//change login password
export const ChangeLoginPassword = (data: any) => {
  return post("/drx/api/change/password.do", data);
};
//Validate token APi
export const ValidateToken = () => {
  return get("drx/api/auth/validatetoken.do");
};

//Top Ribbon Notifications Count
export const TopRibbon = (params: any) => {
  return get("/drx/api/dashboard/prescriptionsCount.do?" + params);
};

//Precriber Details
export const PrecriberDetails = (params: any) => {
  return get("/drx/api/dashboard/prescriberdetails.do?" + params);
};

//Dashboard services
export const DashboardServices = (data: any) => {
  return post("/drx/api/rxpad/getUserServiceLevels.do", data);
};

//Generate Prescriber History Report
export const GeneratePrescriberHistoryReport = (params: any) => {
  return get("/drx/api/reports/prescriberhistory.do?" + params);
};

//On behalf details
export const OnBehalfDetails = (params: any) => {
  return get("/drx/api/dashboard/onbehalfaccessdetails.do?" + params);
};

//Pharmacy Details
export const PharmacyDetailsWithPharmacyCode = (params: any) => {
  return get("/drx/api/rxpad/pharmacy/pharmacyDetails.do?" + params);
};

//get all Notifications
export const Notifications = (params: any) => {
  return get("drx/api/notifications/all.do?" + params);
};

//get All Saved Prescriptions
export const AllSavedPrescriptions = (params: any) => {
  return get("drx/api/rxpad/savedprescriptions/doctor.do?" + params);
};

//Remove All Saved Prescriptions
export const RemoveAllSavedPrescriptionsById = (params: any) => {
  return get("drx/api/rxpad/savedprescriptions/remove/doctor.do?" + params);
};

//get saved prescriptions of patient
export const SavedPrescriptionsPatient = (params: any) => {
  return get("drx/api/rxpad/savedprescriptions/patient.do?" + params);
};

//confirm saved Prescriptions
export const ConfirmSavedPrescriptions = (data: any) => {
  return post(
    "/drx/api/rxpad/savedprescriptions/confirm/savedprescription.do",
    data
  );
};

//saved Prescription edit
export const EditSavedPrescrition = (data: any) => {
  return post("/drx/api/rxpad/savedprescriptions/edit.do    ", data);
};

//Remove All Patient Saved Prescriptions
export const RemoveAllPatientSavedPrescriptionsById = (params: any) => {
  return get("drx/api/rxpad/savedprescriptions/remove/patient.do?" + params);
};

//get all tickets
export const GetTickets = (params: any) => {
  return get("drx/api/tickets/getTickets.do?" + params);
};

//Ticket Info
export const TicketInfo = (params: any) => {
  return get("drx/api/tickets/ticketInfo.do?" + params);
};

//Ticket followup
export const TicketFollowUp = (params: any) => {
  return get("drx/api/tickets/addTicketFollowup.do?" + params);
};

// raise a ticket Initialize tickets
export const InitializeTicket = (params: any) => {
  return get("drx/api/tickets/initializeTicket.do?" + params);
};

//New raise a ticket submit api
export const NewTicketSubmit = (data: any) => {
  return post("drx/api/tickets/submitTicket.do", data);
};

//EPCS-QUEUE get data
export const GetEpcsQueue = (params: any) => {
  return get("drx/api/epcsqueue/prescriptions.do?" + params);
};
//EPCS send to pharmacy
export const EPCSSendToPharmacy = (data: any) => {
  return post("/drx/api/epcsqueue/sendtopharmacy.do", data);
};
//Remove EPCS-QUEUE Data
export const RemoveEpcsQueueById = (params: any) => {
  return get("drx/api/epcsqueue/delete.do?" + params);
};
//rxpad Medication history get data using params- active, inactive, and all
export const GetMedicationHistory = (params: any) => {
  return get("drx/api/rxpad/medicationhistory/medications.do?" + params);
};

//Medication History Drug In Active
export const MedicationHistoryDrugInactive = (data: any) => {
  return post("/drx/api/rxpad/medicationhistory/inactivatedrug.do", data);
};

//Medication History Drug Update
export const MedicationHistoryDrugUpdate = (params: any) => {
  return get("/drx/api/rxpad/medicationhistory/updatedrug.do?" + params);
};

//Medications History cancelRx *(confirm cancellation and confirm prescription)
export const MedicationHistoryCancelRx = (params: any, data: any) => {
  return post("/drx/api/rxpad/medicationhistory/cancelrx.do?" + params, data);
};

//medication History send to cancel rx
export const MedicationHistorySendCancelRx = (data: any) => {
  return post("/drx/api/rxpad/medicationhistory/cancelconfirmrx.do", data);
};

//Medication History->confirm cancellations->remove cancelRx
export const RemoveCancelRxByRxNumber = (data: any) => {
  return post("/drx/api/rxpad/removerx.do", data);
};

//Medication History confirm reprint and refax
export const ConfirmReprintRefaxAPI = (data: any) => {
  return post(
    "/drx/api/rxpad/medicationhistory/confirmReprintRefax.do  ",
    data
  );
};

//medication history send reprint / refax
export const sendReprintRefax = (params: any, data: any) => {
  return post(
    "/drx/api/rxpad/medicationhistory/rePrintandreFax.do?" + params,
    data
  );
};

//medication history print copy
export const MedHistoryPrintCopy = (data: any) => {
  return post("/drx/api/rxpad/medicationhistory/printCopy.do", data);
};

//Post Dated Prescription Count
export const PostDatedPrescriptionCount = (params: any) => {
  return get("/drx/api/postdated/prescriptioncount.do?" + params);
};

//Post Dated Prescription Details
export const PostDatedPrescriptionDetails = (params: any) => {
  return get("/drx/api/postdated/prescriptiondetails.do?" + params);
};

//Post Dated Prescription row delete
export const RemovePostDatedPrescriptionById = (params: any) => {
  return get("/drx/api/postdated/delete.do?" + params);
};

//Post Dated Prescription Edit
export const PostDatedEdit = (params: any) => {
  return get("/drx/api/postdated/edit.do?" + params);
};

//All Rxpad Allergies
export const AllAllergies = (params: any) => {
  return get("/drx/api/rxpad/allergies/allergies.do?" + params);
};

//Allergies row Delete
export const RemoveAllergy = (params: any) => {
  return get("/drx/api/rxpad/allergies/delete.do?" + params);
};

//initialize allergy
export const InitializeAllergy = (params: any) => {
  return get("/drx/api/rxpad/allergies/initalize.do?" + params);
};

//Add New Allergy
export const AddAllergy = (data: any) => {
  return post("/drx/api/rxpad/allergies/add.do", data);
};

//initialize allergies for edit
export const InitializeAllergyForEdit = (params: any) => {
  return get("/drx/api/rxpad/allergies/initalizeedit.do?" + params);
};

export const UpdateAllergy = (data: any) => {
  return post("/drx/api/rxpad/allergies/edit.do", data);
};

//Fav drugs Alphabets with color code present in the list
export const FavDrugsAlphaColors = (params: any) => {
  return get("/drx/api/rxpad/favorite/drugs/alphabetizaton.do?" + params);
};

//practice fav drugs alphabet colors
export const PracticeFavDrugsAlphaColors = (params: any) => {
  return get(
    "/drx/api/rxpad/patientprofile/practicefavoritedrug/list/alphabetizaton.do?" +
      params
  );
};

//Rxpad -> Get all FavDrugs with alphabetic filtering
export const FavDrugs = (params: any) => {
  return get("/drx/api/rxpad/favorite/drugs.do?" + params);
};

//Remove Rxpad -> FavDrugs By Id
export const RemoveFavDrugsById = (params: any) => {
  return get("/drx/api/rxpad/favorite/delete.do?" + params);
};

//confirm prescription fav drugs
export const ConfirmFavDrugsPrescription = (data: any) => {
  return post("/drx/api/rxpad/favorite/confirm/favoritedrugs.do", data);
};

//EPA Holding Queue Count Data
export const EPAHoldingQueueCount = (params: any) => {
  return get("drx/api/rxpad/epaholdingqueue/prescriptioncount.do?" + params);
};

//EPA Holding Queue Details Data
export const EPAHoldingQueueDetails = (params: any) => {
  return get("/drx/api/rxpad/epaholdingqueue/prescriptionlist.do?" + params);
};

//EPA Holding Open Accelerator
export const EPATokenAcceleratorIFrame = (params: any) => {
  return get("/drx/api/rxpad/epaholdingqueue/epatokenaccelerator.do?" + params);
};

//EPA Holding Queue delete row by selected id
export const RemoveEPAHoldingsById = (params: any) => {
  return get("/drx/api/rxpad/epaholdingqueue/delete.do?" + params);
};

//EPA holding queue confirm prescriptions
export const EPAConfirmPrescriptions = (data: any) => {
  return post(
    "/drx/api/rxpad/epaholdingqueue/confirmMultipleEpaPrescription.do",
    data
  );
};

//EPA holding confirm prescriptions for refills
export const EPAConfirmPrescriptionsForRefills = (data: any) => {
  return post(
    "/drx/api/rxpad/epaholdingqueue/confirmMultipleEpaPrescriptionForRefill.do",
    data
  );
};

//EPA Holding Queue Print
export const EPAHoldingQueuePrint = (data: any) => {
  return post("/drx/api/rxpad/epaholdingqueue/print.do", data);
};

//EPA holding send to pharmacy
export const EPAHoldingSendToPharmacy = (params: any, data: any) => {
  return post(
    "/drx/api/rxpad/epaholdingqueue/epasendtopharmacy.do?" + params,
    data
  );
};

//EPA holding send to pharmacy for refills
export const EPAHoldingSendToPharmacyForRefills = (params: any, data: any) => {
  return post(
    "/drx/api/rxpad/epaholdingqueue/epasendtopharmacyrefill.do?" + params,
    data
  );
};

//Epa re initiate
export const EPAHoldingReInitiate = (data: any) => {
  return post("/drx/api/rxpad/epaholdingqueue/modifyEpa.do", data);
};
//Adverse Effect
export const AdverseEffect = (params: any) => {
  return get("/drx/api/rxpad/drugknowledge.do?" + params);
};

//EPA Worklist Count data
export const EPAWorklistCount = (params: any) => {
  return get("/drx/api/rxpad/epaworklist/prescriptioncount.do?" + params);
};

//EPA Worklist Details
export const EPAWorklistDetails = (params: any) => {
  return get("/drx/api/rxpad/epaworklist/prescriptionlist.do?" + params);
};

// Favorite Pharmacy Data List
export const FavoritePharmacyDataList = (params: any) => {
  return get("/drx/api/rxpad/favouritepharmacy/pharmacies.do?" + params);
};

//Remove Favorite Pharmacy Data List
export const RemoveFavoritePharmacyDataListById = (params: any) => {
  return get("/drx/api/rxpad/favouritepharmacy/delete.do?" + params);
};

//DrugSearch Ajax Call
export const DrugSearchAjaxCall = (params: any) => {
  return get("/drx/api/rxpad/drug/drugNameStartingWith.do?" + params);
};

//RxChange Alerts count
export const RxChangeAlertsCount = (params: any) => {
  return get("/drx/api/rxchangealerts/prescriptioncount.do?" + params);
};

//RxChange Alerts list
export const RxChangeAlertsList = (params: any) => {
  return get("/drx/api/rxchangealerts/prescriptionlist.do?" + params);
};

//RxChange Alerts details
export const RxChangeAlertsDetails = (params: any) => {
  return get("/drx/api/rxchangealerts/prescriptiondetails.do?" + params);
};

//RxChange Alerts Delete List
export const RemoveRxChangeAlertsById = (params: any) => {
  return get("/drx/api/rxchangealerts/delete.do?" + params);
};

//Rxchange alerts send to pharmacy
export const RxChangeAlertsSendToPharmacy = (body: any) => {
  return post("/drx/api/rxchangealerts/sendtopharmacy.do", body);
};

//rxchange alerts selectedMedRequest
export const RxChangeAlertsSelectedMedRequest = (data: any) => {
  return post("/drx/api/rxchangealerts/selectedMedRequest.do", data);
};

//RxchangeAlerts approved with changes
export const RxChangeAlertsApprovedWithChanges = (body: any) => {
  return post("/drx/api/rxchangealerts/approvedWithChanges.do", body);
};

//Rxchange approved with changes
export const RxChangeApprovedWithChanges = (body: any) => {
  return post("/drx/api/rxchange/approvedWithChanges.do", body);
};

//RxFill Alerts Count
export const RxFillAlertsCount = (params: any) => {
  return get("/drx/api/rxfillalerts/prescriptioncount.do?" + params);
};

//RxFill Alerts List
export const RxFillAlertsList = (params: any) => {
  return get("/drx/api/rxfillalerts/prescriptionlist.do?" + params);
};

//RxFill Alerts Details
export const RxFillAlertsDetails = (params: any) => {
  return get("/drx/api/rxfillalerts/prescriptiondetails.do?" + params);
};

//RxFill Alerts List Remove
export const RemoveRxFillAlertsDetails = (params: any) => {
  return get("/drx/api/rxfillalerts/delete.do?" + params);
};

//Pharmacy Search Ajax Call to display pharmacies
export const PharmacySearchAjaxCall = (params: any) => {
  return get("/drx/api/rxpad/pharmacy/pharmacyNameContains.do?" + params);
};

//Pharmacy Search
export const SearchPharmacy = (params: any) => {
  return get("/drx/api/rxpad/pharmacy/search.do?" + params);
};

//Add to Fav Pharmacy from Pharmacy Search
export const AddToFavPharmacy = (params: any) => {
  return get("/drx/api/rxpad/favouritepharmacy/add.do?" + params);
};

//Refill Alerts Count
export const RefillAlertsCount = (params: any) => {
  return get("/drx/api/refillalerts/prescriptioncount.do?" + params);
};

//Refill Alerts List
export const RefillAlertsList = (params: any) => {
  return get("/drx/api/refillalerts/prescriptionlist.do?" + params);
};

//Refill Alerts Details
export const RefillAlertsDetails = (params: any) => {
  return get("/drx/api/refillalerts/prescriptiondetails.do?" + params);
};

//Refill Alerts delete row
export const RemoveRefillAlertsById = (params: any) => {
  return get("/drx/api/refillalerts/delete.do?" + params);
};

//refill alerts send to pharmacy
export const RefillAlertsSendToPharmacy = (params: any, data: any) => {
  return post("/drx/api/refillalerts/sendtopharmacy.do?" + params, data);
};

//refill alerts replace
export const RefillAlertsReplace = (data: any) => {
  return post("/drx/api/refillalerts/replace.do", data);
};

//Pending Refills counts
export const PendingRefillsCount = (params: any) => {
  return get("/drx/api/refills/prescriptioncount.do?" + params);
};

//Pending Refills Details
export const PendingRefillsDetails = (params: any) => {
  return get("/drx/api/refills/prescriptiondetails.do?" + params);
};

//Pending Refills remove Data
export const RemovePendingRefillsById = (params: any) => {
  return get("/drx/api/refills/delete.do?" + params);
};

//Pending Refills generate reports
export const PendingRefillsGenerateReports = (params: any) => {
  return get("/drx/api/reports/pendingrefills.do?" + params);
};

//Pending refills send to pharmacy
export const PendingRefillsSendToPharmacy = (params: any, data: any) => {
  return post("/drx/api/refills/sendtopharmacy.do?" + params, data);
};

//Pending refills replace send to pharmacy
export const PendingRefillsReplace = (data: any) => {
  return post("/drx/api/refills/replace.do", data);
};

//Generate Saved Prescription Report
export const GenerateSavedPrescriptionReport = (params: any) => {
  return get("/drx/api/reports/generatesavedprescriptionreport.do?" + params);
};

//Generate Patient Pharmacies Report
export const GeneratePatientPharmaciesReport = (params: any) => {
  return get("/drx/api/reports/generatepatientpharmaciesreport.do?" + params);
};

//Initializer
export const Initializer = () => {
  return get("/drx/api/reports/initialize.do");
};

//Initialize user activity
export const InitializeUserActivity = (params: any) => {
  return get("/drx/api/reports/initializeUserActivity.do?" + params);
};
//User Activity generate reports
export const UserActivityGenerateReports = (params: any) => {
  return get("/drx/api/reports/generateUserActivityReport.do?" + params);
};

//Rxchange Count
export const RxchangeCount = (params: any) => {
  return get("/drx/api/rxchange/prescriptioncount.do?" + params);
};

//Rxchange Details
export const RxchangeDetails = (params: any) => {
  return get("/drx/api/rxchange/prescriptiondetails.do?" + params);
};

//Rxchange Details remove data
export const RemoveRxchangeDetailsById = (params: any) => {
  return get("/drx/api/rxchange/delete.do?" + params);
};

//Rxchange Medication Request Drug api
export const RxchangeMedicationRequestDrug = (params: any) => {
  return get("/drx/api/rxchange/selectedMedRequest.do?" + params);
};

//Rxchange Send to Pharmacy
export const RxChangeSendToPharmacy = (data: any) => {
  return post("/drx/api/rxchange/sendtopharmacy.do", data);
};

//Clinic Details
export const ClinicDetails = (params: any) => {
  return get("/drx/api/myprofile/clinic/locations.do?" + params);
};

//Remove Clinic
export const RemoveClinic = (params: any) => {
  return get("/drx/api/myprofile/clinic/delete.do?" + params);
};

//Generate Patient Medication Report
export const GeneratePatientMedicationReport = (params: any) => {
  return get("/drx/api/reports/generatePatientMedicationReport.do?" + params);
};

//Patient Profile-->Pharmacy information
export const PatientProfilePharmacyInfo = (params: any) => {
  return get("/drx/api/rxpad/patientprofile/pharmacy/list.do?" + params);
};

//Patient Profile--> Remove Pharmacy information
export const RemovePatientProfilePharmacyInfoById = (params: any) => {
  return get("/drx/api/rxpad/patientprofile/pharmacy/remove.do?" + params);
};

//Patient Profile-->Add Pharmacy information
export const AddPatientProfilePharmacyInfoById = (params: any) => {
  return get("/drx/api/rxpad/patientprofile/pharmacy/add.do?" + params);
};

//Patient Profile --> insurance info
export const PatientProfileInsuranceInfo = (params: any) => {
  return get("/drx/api/rxpad/patientprofile/insurance/info.do?" + params);
};

//BriefCase Count
export const BriefCaseCount = (params: any) => {
  return get("/drx/api/briefcase/count.do?" + params);
};

//BriefCase List
export const BriefCaseList = (params: any) => {
  return get("/drx/api/briefcase/list.do?" + params);
};

//Brief case report download
export const BriefCaseReportDownload = (params: any) => {
  return get("/drx/api/briefcase/report/download.do?" + params);
};

//BriefCase List Delete
export const RemoveBriefCaseCancelrxById = (params: any) => {
  return get("/drx/api/briefcase/delete.do?" + params);
};

//BriefCase CancelRx Details
export const BriefCaseCancelrxDetails = (params: any) => {
  return get("/drx/api/briefcase/cancelrx/details.do?" + params);
};

//Default Physician List of dropdowns
export const DefaultPhysicianDropDownList = (params: any) => {
  return get(
    "/drx/api/rxpad/patientprofile/defaultphysician/details.do?" + params
  );
};

//Default physician Set to the respective Patient
export const SetDefaultPhysician = (params: any) => {
  return get(
    "/drx/api/rxpad/patientprofile/defaultphysician/update.do?" + params
  );
};

//Practice Fav Drugs List
export const PracticeFavDrugsList = (params: any) => {
  return get(
    "/drx/api/rxpad/patientprofile/practicefavoritedrug/list.do?" + params
  );
};

//practice Fav Drug Delete by id
export const RemovePracticeFavDrugsListById = (params: any) => {
  return get(
    "/drx/api/rxpad/patientprofile/practicefavoritedrug/delete.do?" + params
  );
};

//confirm prescriptions practice fav drugs
export const ConfirmPracticeFavDrugsPresc = (data: any) => {
  return post("/drx/api/rxpad/favorite/confirm/favoritepracticedrugs.do", data);
};

//Myprofile-> fav drugs list
export const MyProfileFavDrugsList = (params: any) => {
  return get("/drx/api/myprofile/favoritedrugs/list.do?" + params);
};

//My profile remove fav drug by id
export const RemoveMyProfileFavDrugsById = (params: any) => {
  return get(
    "/drx/api/myprofile/favoritedrugs/removefromfavoritedrugs.do?" + params
  );
};

//My profile fav drugs Add new Fav drug search
export const FavoriteDrugSearchWithDrugName = (params: any) => {
  return get("/drx/api/myprofile/favoritedrugs/drugsearch.do?" + params);
};

//my profile -> Initialize Add Clinic
export const InitializeAddClinic = (params: any) => {
  return get("/drx/api/myprofile/clinic/create/initialize.do?" + params);
};

//my profile -> Add Clinic
export const MyProfileAddNewClinic = (data: any) => {
  return post("/drx/api/myprofile/clinic/create.do", data);
};

//my profile -> update clinic initialize
export const InitializeUpdateClinic = (params: any) => {
  return get("/drx/api/myprofile/clinic/update/initialize.do?" + params);
};

//My profile -> update Clinic
export const UpdateNewClinic = (params: any, data: any) => {
  return post("/drx/api/myprofile/clinic/update.do?" + params, data);
};

//my profile Drug Interaction level initial data
export const DrugInteractionInitialize = (params: any) => {
  return get("/drx/api/myprofile/druginteractionlevels/get.do?" + params);
};

//my profile Drug Interaction level save
export const DrugInteractionSave = (data: any) => {
  return post("/drx/api/myprofile/druginteractionlevels/save.do", data);
};

//Rx fill count
export const RxFillCount = (params: any) => {
  return get("/drx/api/rxfill/prescriptioncount.do?" + params);
};
//rx fill list
export const RxFillList = (params: any) => {
  return get("/drx/api/rxfill/prescriptionlist.do?" + params);
};

//Rx fill Details
export const RxFillDetails = (params: any) => {
  return get("/drx/api/rxfill/prescriptiondetails.do?" + params);
};

//Rx fill delete by Id
export const RemoveRxFillById = (params: any) => {
  return get("/drx/api/rxfill/delete.do? " + params);
};

// prescription Report
export const GetPrescriptionReport = (params: any) => {
  return get("/drx/api/rxpad/prescriptionreport/create.do?" + params);
};

//Rx alerts Count
export const RxAlertCount = (params: any) => {
  return get("/drx/api/rxalerts/prescriptioncount.do?" + params);
};

//Rx alerts List
export const RxAlertList = (params: any) => {
  return get("/drx/api/rxalerts/prescriptionlist.do?" + params);
};

//Rx Alerts Details
export const RxAlertDetails = (params: any) => {
  return get("/drx/api/rxalerts/prescriptiondetails.do?" + params);
};

//Rx Alerts Delete
export const RemoveRxAlertById = (params: any) => {
  return get("/drx/api/rxalerts/delete.do?" + params);
};

//Rx Alerts Print
export const RxAlertPrint = (data: any) => {
  return post("/drx/api/rxalerts/printalert.do", data);
};

//React to Retro
export const ReactToRetro = (params: any) => {
  return get("/drx/api/drxupgrade/navigateBackToRetroTheme.do?" + params);
};

//Rxpad pharmacy dropdown
export const PharmacyHistoryDropDownValues = (params: any) => {
  return get("/drx/api/rxpad/patient/pharmacyhistory.do?" + params);
};

//Rxpad pharmacy populate
export const PharmacyPopulate = (data: any) => {
  return post("/drx/api/rxpad/pharmacyPopulate.do", data);
};

//Initialize RxPad
export const InitializeRxPad = (params: any) => {
  return get("/drx/api/rxpad/initializerx.do?" + params);
};

//Save button in summary page
export const SAVE = (data: any) => {
  return post("/drx/api/rxpad/savedprescriptions/save.do", data);
};

//Next prescription ADD NEW +
export const ADDNEWPRESC = (data: any) => {
  return post("/drx/api/rxpad/next.do", data);
};

//Confirm prescription (submit prescriptions)
export const SubmitPresctiptions = (data: any) => {
  return post("/drx/api/rxpad/confirm/prescription.do", data);
};

//RTBP Check (Patient Benefits.....)
export const RTBPCHECK = (data: any) => {
  return post("/drx/api/rxpad/rtpb.do", data);
};

//RTPB pharmacy populate
export const RTBPCHECKPharmacyPopulate = (data: any) => {
  return post("/drx/api/rxpad//rtpb_pharmacypopulate.do", data);
};

//Drug Search alternatives and varients
export const DrugSearchAlternativesAndVarients = (data: any) => {
  return post("/drx/api/rxpad/drug/search/results.do", data);
};

//Drug Populate
export const DrugPopulate = (data: any) => {
  return post("/drx/api/rxpad/drugpopulate.do", data);
};

//staff Auth search by lastname
export const staffAuthorizationSearchbyLastname = (params: any) => {
  return get(
    "/drx/api/myprofile/staffAuthorization/searchbylastname.do?" + params
  );
};

//ss med history
export const SSMedHistory = (params: any) => {
  return get("/drx/api/rxpad/ssmedicationhistory/records.do?" + params);
};

//my profile - personal INfo
export const MyProfilePersonalInfo = (params: any) => {
  return get(
    "/drx/api/myprofile/personalinformation/personalprofile.do?" + params
  );
};

//patient Search
export const PatientSearchDetails = (params: any, data: any) => {
  return post("/drx/api/patientsearch/details.do?" + params, data);
};

//Patient Registration
export const PatientRegistrationAPI = (data: any) => {
  return post("/drx/api/patient/register.do", data);
};

//Patient Profile - patient informaion
export const PatientProfilePI = (params: any) => {
  return get("/drx/api/rxpad/patientprofile/info.do?" + params);
};

//Patient profile - update
export const PatientProfilePIUpdate = (data: any) => {
  return post("/drx/api/rxpad/patientprofile/update.do", data);
};

//Update Clinic Location
export const UpdateClinicLocation = (params: any) => {
  return get("/drx/api/dashboard/prescriber/updateLocation.do?" + params);
};

//Add to fav drugs (physician list)
export const AddToPhysicianList = (data: any) => {
  return post("/drx/api/myprofile/favoritedrugs/addToFavoriteDrugs.do", data);
};

export const AddToPracticeList = (data: any) => {
  return post(
    "/drx/api/myprofile/favoritedrugs/addToPracticeFavoriteDrugs.do",
    data
  );
};

//patient prescriptio report
export const GeneratePatientPrescriptionReport = (params: any) => {
  return get("/drx/api/reports/generatepatientprescriptionReport.do?" + params);
};

//Update Email Reminder
export const updateEmailReminder = (params: any) => {
  return get(
    "/drx/api/myprofile/personalinformation/updateEmailReminder.do?" + params
  );
};

//Update Patient Email
export const updatePatientEmail = (params: any) => {
  return get("/drx/api/myprofile/personalinformation/updateEmail.do?" + params);
};

//Update Patient Demographics
export const updatePatientDemographics = (params: any) => {
  return get(
    "/drx/api/rxpad/patientprofile/updatePatientDemographics.do?" + params
  );
};

//Update Patient Address
export const updatePatientAddress = (params: any) => {
  return get("/drx/api/rxpad/patientprofile/updatePatientAddress.do?" + params);
};

//rxpad exhub unique change(Benefit source)
export const refreshDrugInfo = (data: any) => {
  return post("/drx/api/rxpad/refreshDrugInfo.do", data);
};

//rxpad change drug
export const ChangeDrug = (data: any) => {
  return post("/drx/api/rxpad/changeDrug.do", data);
};

//rxpad summary send to pharmacy
export const summarySendToPharmacyAPI = (params: any, data: any) => {
  return post("/drx/api/rxpad/sendtopharmacy.do?" + params, data);
};

export const staffAuthorizationUpdate = (data: any) => {
  return post("/drx/api/myprofile/staffAuthorization/update.do", data);
};

//rxpad save to med history
export const saveToMedHistory = (data: any) => {
  return post("/drx/api/rxpad/addToMedicationHistory.do", data);
};

// rxpad print
export const RxPrint = (data: any) => {
  return post("/drx/api/rxpad/rxprint.do", data);
};

// Therapeutical alternatives
// export const TherapeuticalAlternatives = (data: any) => {
//   return post("/drx/api/rxpad/therapeuticAlternatives.do", data);
// };

//Check Pharmacy benefits
export const checkPharmacyBenefits = (data: any) => {
  return post("/drx/api/rxpad/checkPharmacyBenefits.do", data);
};

//Drug to Food Interactions
export const DrugtoFoodInteractions = (params: any) => {
  return get("/drx/api/rxpad/drugtofoodinteractions.do?" + params);
};

//Allergies Inactivate And Activate
export const inactivateAndActivate = (data: any) => {
  return post("/drx/api/rxpad/allergies/inactivateAndActivate.do", data);
};

export const EPCSFailedReport = (params: any) => {
  return get("/drx/api/reports/epcsfailedhistory.do?" + params);
};

export const EPCSSuccessReport = (params: any) => {
  return get("/drx/api/reports/prescriberEpcsHistory.do?" + params);
};

export const EPCSAuditReport = (params: any) => {
  return get("/drx/api/reports/prescriberEpcsAuditHistory.do?" + params);
};

export const requestForDemoEmailSendAPI = (params: any) => {
  return get("/drx/api/dashboard/prescriber/requestForDemo.do?" + params);
};

export const docreeDoctorInfo = (data: any) => {
  return post("/drx/api/rxpad/doceree/doctorInfo.do", data);
};

export const NdcHistory = (params: any) => {
  return get("/drx/api/rxpad/doceree/ndcHistory.do?" + params);
};

export const MarkAsRead = (params: any) => {
  return get("/drx/api/notifications/updatenotifytimestamp.do?" + params);
};

export const LegacyHistoryData = (params: any) => {
  return get("/drx/api/rxpad/legacymedhistory/records.do?" + params);
};

export const AdherenceReview = (params: any) => {
  return get("/drx/api/rxpad/adherence/review.do?" + params);
};
